<div class="card-header bg-primary" style="padding: 20px 10px" *ngIf="header">
  <div class="row">
    <div [class]="type === 'masive_farm' ? 'col-12 ' :'col-6'">
      <h4 class="m-0">{{ "speed-component.speeds-of" | translate }} {{feeder?.name}}</h4>
    </div>
    <div
      class="d-flex justify-content-end align-items-center"
      [class]="type === 'masive_farm' ? 'col-12' :'col-6 '"
    >
      <label class="switch m-0">
        <input
          type="checkbox"
          [value]="validateCheckSpeed()"
          [checked]="validateCheckSpeed()"
          (change)="changeStatusSpeed($event.target.checked)"
        />
        <span class="slider round"> </span>
      </label>
    </div>
  </div>
</div>
<div class="card-body">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex gap-10 align-items-center">
      <b style="font-size: 16px">
        {{validateInputsSpeed('view_mode_speed') === 'orbital' ? ('speed-config.orbital' | translate) : ('speed-config.normal' | translate)}}</b
      >
      <span
        *ngIf="type && type === 'masive'"
        class="badge badge-dark c-pointer help-badge"
        placement="bottom"
        container="body"
        [ngbTooltip]="'speed-component.displayed-values-hint' | translate"
        >?</span
      >
    </div>

    <div class="d-flex gap-10" *ngIf="type === 'masive'">
      <button class="btn btn-sm btn-danger" (click)="changeStatusSpeed(false)">
        <i class="fa fa-power-off" aria-hidden="true"></i>
      </button>
      <button class="btn btn-sm btn-success" (click)="changeStatusSpeed(true)">
        <i class="fa fa-power-off" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <br />

  <ng-container *ngIf="validateViewSpeed()">
    {{ "speed-config.high" | translate }}
    <div class="d-flex align-items-center">
      <input
        class="w-100"
        type="range"
        list="list_status_high_speed"
        max="100"
        min="37.5"
        step="12.5"
        [ngModel]="validateInputsSpeed('status_high_speed')"
        name="status_high_speed"
        id="low_speed"
        (change)="changeInput($event.target,'status_high_speed')"
      />
      <datalist id="list_status_high_speed">
        <option *ngFor="let item of optionSpeed;" [value]="item" [label]="item + '%'">
          <p class="m-0">{{item}}</p>
        </option>
      </datalist>
    </div>
    <div class="d-flex justify-content-between">
      <p *ngFor="let item of optionSpeed;">{{item}}</p>
    </div>
    {{ "speed-config.low" | translate }}
    <div class="d-flex align-items-center">
      <input
        class="w-100"
        type="range"
        list="list_status_low_speed"
        max="100"
        min="37.5"
        step="12.5"
        [ngModel]="validateInputsSpeed('status_low_speed')"
        name="status_low_speed"
        id="low_speed"
        (change)="changeInput($event.target,'status_low_speed')"
      />
      <datalist id="list_status_low_speed">
        <option *ngFor="let item of optionSpeed;" [value]="item" [label]="item + '%'">
          <p class="m-0">{{item}}</p>
        </option>
      </datalist>
    </div>
    <div class="d-flex justify-content-between">
      <p *ngFor="let item of optionSpeed;">{{item}}</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!validateViewSpeed()">
    <div class="d-flex align-items-center">
      <input
        class="w-100"
        type="range"
        list="list_status_speed"
        max="100"
        min="37.5"
        step="12.5"
        [ngModel]="validateInputsSpeed('status_speed')"
        name="status_speed"
        id="low_speed"
        (change)="changeInput($event.target,'status_speed')"
      />
      <datalist id="list_status_speed">
        <option *ngFor="let item of optionSpeed;" [value]="item" [label]="item + '%'">
          <p class="m-0">{{item}}</p>
        </option>
      </datalist>
    </div>
    <div class="d-flex justify-content-between">
      <p *ngFor="let item of optionSpeed;">{{item}}</p>
    </div>
  </ng-container>

  <div class="d-flex align-items-center justify-content-between mb-2">
    <div [ngClass]="{'d-flex align-items-center': type === 'individual'}">
      <ng-container *ngIf="validateVersion()">
        <div class="form-check mr-2">
          <input
            class="form-check-input"
            type="radio"
            [name]="nameInput()"
            value="normal"
            [id]="nameInput()"
            [ngModel]="validateInputsSpeed('view_mode_speed')"
            (change)="changeInput('normal','view_mode_speed')"
            [checked]="validateInputsSpeed('view_mode_speed') === 'normal'"
          />
          <label class="form-check-label" [for]="nameInput()"> {{ "speed-config.normal" | translate }} </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            [name]="nameInput()"
            value="orbital"
            [ngModel]="validateInputsSpeed('view_mode_speed')"
            (change)="changeInput('orbital','view_mode_speed')"
            [checked]="validateInputsSpeed('view_mode_speed') === 'orbital'"
            id="orbital"
          />
          <label class="form-check-label" for="orbital"> {{ "speed-config.orbital" | translate }} </label>
        </div>
      </ng-container>
    </div>
    <div class="center" [ngClass]="{'d-flex align-items-center': type === 'individual'}">
      <div class="mr-2" *ngIf="!header && type !== 'masive'">
        <label class="switch m-0">
          <input
            type="checkbox"
            [value]="validateCheckSpeed()"
            [checked]="validateCheckSpeed()"
            (change)="changeStatusSpeed($event.target.checked)"
          />
          <span class="slider round"> </span>
        </label>
      </div>
      <div class="d-flex gap-10">
        <button
          *ngIf="type === 'masive'"
          class="btn btn-secondary p-0 pl-2 pr-2"
          [ngClass]="{'mt-1': type === 'masive'}"
          (click)="getMasiveSpeed()"
        >
          {{ "speed-component.request-value" | translate }}
        </button>
        <button
          class="btn btn-secondary p-0 pl-2 pr-2"
          [disabled]="validateSpeedButton()"
          [ngClass]="{'mt-1': type === 'masive'}"
          (click)="changeSpeed()"
        >
          {{ "general.send" | translate }}
        </button>
      </div>

      <div *ngIf="type === 'individual'">
        <button
          class="btn btn-secondary p-0 pl-2 pr-2 ml-1"
          [ngClass]="{'mt-1': type === 'masive'}"
          (click)="getSpeedgetSpeed()"
        >
          <em class="fa fa-undo"></em>
        </button>
      </div>
    </div>
  </div>
</div>
